import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LegalDocumentCard = ({ 
  title, 
  description, 
  icon, 
  lastUpdated, 
  onClick, 
  isActive = false,
  documentType = 'policy'
}) => {
  const getDocumentIcon = () => {
    switch (documentType) {
      case 'impressum':
        return 'Building2';
      case 'privacy':
        return 'Shield';
      case 'cookies':
        return 'Cookie';
      case 'gdpr':
        return 'FileText';
      case 'terms':
        return 'ScrollText';
      default:
        return icon || 'FileText';
    }
  };

  const getStatusColor = () => {
    const daysSinceUpdate = Math.floor((new Date() - new Date(lastUpdated)) / (1000 * 60 * 60 * 24));
    if (daysSinceUpdate < 30) return 'text-success';
    if (daysSinceUpdate < 90) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div 
      className={`group relative bg-card border rounded-brand p-6 transition-brand hover-lift cursor-pointer ${
        isActive ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/50'
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-brand-sm ${
          isActive ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground group-hover:bg-primary group-hover:text-primary-foreground'
        } transition-brand`}>
          <Icon name={getDocumentIcon()} size={24} />
        </div>
        
        <div className="flex items-center space-x-2">
          <div className={`w-2 h-2 rounded-full ${getStatusColor()?.replace('text-', 'bg-')}`}></div>
          <span className={`text-xs font-medium ${getStatusColor()}`}>
            Updated
          </span>
        </div>
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-brand">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {description}
      </p>
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">
          Last updated: {new Date(lastUpdated)?.toLocaleDateString()}
        </span>
        
        <Button
          variant="ghost"
          size="sm"
          className="opacity-0 group-hover:opacity-100 transition-brand"
        >
          <Icon name="ArrowRight" size={16} />
        </Button>
      </div>
      {isActive && (
        <div className="absolute top-4 right-4">
          <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
        </div>
      )}
    </div>
  );
};

export default LegalDocumentCard;